import React from 'react';
import { ManagementAdjSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';

const SLUG = 'mgmt-confidence';

interface MgmtConfidenceData {
  managementAdjValue?: number;
  dbManagementAdjValue?: number;
  updatingPStar?: boolean;
  selectedStockId?: number | string | null;
}

export default function MgmtConfidence(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const pageData = usePageDataContextOptional();
  const data = getRegistryData<MgmtConfidenceData>(props);
  const pageUpdatingPStar = pageData?.data?.updatingPStar as boolean | undefined;
  const pageSelectedStockId = pageData?.data?.selectedStockId as number | string | null | undefined;

  const dbManagementAdjValue = data.dbManagementAdjValue ?? 0.95;
  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const managementAdjValue =
    formValue ?? data.managementAdjValue ?? dbManagementAdjValue ?? 0.95;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = parseFloat(e.target.value);
      formContext?.setValue(SLUG, newValue);
    },
    [formContext]
  );

  const updatingPStar = data.updatingPStar ?? pageUpdatingPStar ?? false;
  const selectedStockId = data.selectedStockId ?? pageSelectedStockId ?? null;

  return (
    <ManagementAdjSlider
      managementAdjValue={managementAdjValue}
      dbManagementAdjValue={dbManagementAdjValue}
      handleManagementAdjChange={handleChange}
      updatingPStar={updatingPStar}
      selectedStockId={selectedStockId}
    />
  );
}
